<div class="d-flex gap-10 ai-center f-s-18 m-t-30 m-b-20 f-w-600 text-blackTitle">
  <i-tabler name="moon-stars" class="icon-25 stroke-1" />
  Tema
</div>
<div class="d-flex ai-center gap-10">
  <button type="button" class="btn" [class.flat-button]="!isDarkMode" [class.stroked-button]="isDarkMode"
    (click)="setTheme('light-mode')">
    Claro
  </button>

  <button type="button" class="btn" [class.flat-button]="isDarkMode" [class.stroked-button]="!isDarkMode"
    (click)="setTheme('dark-mode')">
    Escuro
  </button>
</div>